import script from "./AdvisorProspectComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AdvisorProspectComponent.vue?vue&type=script&setup=true&lang=js"

import "./AdvisorProspectComponent.vue?vue&type=style&index=0&id=5986b7d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5986b7d2"]])

export default __exports__